const locale: Locale = {
  ko: {
    consented: 'Top 5',
    waiting: '답변 대기중인 청원',
    recent: '최근 답변된 청원',
    reject: '최근 반려된 청원',
  },
  en: {
    consented: 'Top 5',
    waiting: 'Waiting For Answer',
    recent: 'Recently Answered Petitions',
    reject: 'Recently Rejected Petitions',
  },
}

export default locale
